export const trialDays = 14;

